<template>
  <el-card
    class="box-card experience-wrapper--section-whats_included"
    shadow="never"
  >
    <div slot="header" class="clearfix">
      <h2 class="section-title">
        <router-link v-if="permalink" :to="tabRoute"
          ><i class="el-icon-link"
        /></router-link>

        <span>{{ $tc(`${base}.title_${type}`, 1) }}</span>
      </h2>
    </div>

    <div class="experience-wrapper--section-whats_included-content">
      <div class="section section-whats_included d--grid">
        <div
          v-for="(item, i) in included"
          :key="`whats-included-${i}`"
          class="whats_included--wrapper"
        >
          <div class="whats_included--container d--grid">
            <div>
              <i class="el-icon-circle-check" :style="{ color: '#67C23A' }" />
            </div>
            <div>
              <p v-if="!!item.title" class="whats_included--title">{{
                item.title
              }}</p>
              <p
                v-if="!!item.description"
                class="whats_included--description"
                >{{ item.description }}</p
              >
              <el-button
                type="text"
                size="mini"
                class="show-more"
                @click="showMore"
              >
                {{ $t(`general.show_more`) }}
              </el-button>
            </div>
          </div>
        </div>

        <h2 v-if="noIncluded.length" class="no-included">{{
          $tc(`${base}.title_${type}`, 0)
        }}</h2>

        <div
          v-for="(item, i) in noIncluded"
          :key="`whats-not-included-${i}`"
          class="whats_included--wrapper"
        >
          <div class="whats_included--container d--grid">
            <div>
              <i class="el-icon-circle-close" :style="{ color: '#F56C6C' }" />
            </div>
            <div>
              <p v-if="!!item.title" class="whats_included--title">{{
                item.title
              }}</p>
              <p
                v-if="!!item.description"
                class="whats_included--description"
                >{{ item.description }}</p
              >
              <el-button
                type="text"
                size="mini"
                class="show-more"
                @click="showMore"
              >
                {{ $t(`general.show_more`) }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'LadTabWhatsIncluded',
  data() {
    return {
      base: 'experience.whats_included',
    }
  },
  computed: {
    ...mapGetters('device', ['isMobile']),
    ...mapState('experience', {
      exWhatsIncluded: 'whats_included',
      permalink: (state) => state.experience.permalink.default,
      type: (state) => state.experience.type,
    }),
    tabRoute() {
      return {
        name: 'product-permalink',
        params: {
          type: this.$t(`router.product_permalink.type.${this.type}`),
          permalink: this.permalink,
        },
      }
    },
    included() {
      return this.exWhatsIncluded.filter((t) => t.included)
    },
    noIncluded() {
      return this.exWhatsIncluded.filter((t) => !t.included)
    },
  },
  mounted() {
    // Obtener los elementos a procesar
    const items = document.querySelectorAll('p.whats_included--description')

    // Filtrar solo los truncados
    const truncatedItems = [...items].filter(
      (p) => p.offsetHeight < p.scrollHeight
    )

    // Agregar atributo a los truncados
    truncatedItems.forEach((item) => item.setAttribute('data-truncated', ''))
  },
  methods: {
    showMore(event) {
      const p = event.target.parentNode.previousElementSibling
      if (p) {
        p.removeAttribute('data-truncated')
        p.classList.add('show-all')
      }
    },
  },
}
</script>

<style lang="scss">
.experience-wrapper--section-whats_included {
  .section-whats_included {
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;

    .whats_included {
      &--container {
        grid-template-columns: auto 1fr;
        grid-gap: 10px;

        & > div:first-child {
          i {
            font-size: 24px;
            color: #6ec12a;
            position: relative;
            bottom: -3px;
            margin-right: 0.3em;
          }
        }

        p {
          margin: 0;
        }

        .show-more {
          display: none;
          float: right;
          padding: 0;

          & > span {
            padding: 7px 0;
            display: inline-block;
          }
        }
      }

      &--title {
        font-weight: 700;
      }

      &--description {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        font-style: italic;

        &[data-truncated] + .show-more {
          display: inline;
        }

        &.show-all {
          display: inline-block;
        }
      }
    }

    .no-included {
      grid-column: 1 / 3;
      padding: 20px 0;
      border-bottom: 1px solid #ebeef5;
    }

    @media screen and (max-width: 700px) {
      grid-template-columns: 1fr;
      grid-gap: 10px;

      .no-included {
        grid-column: 1;
      }
    }
  }
}
</style>
